"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _systemSleep = _interopRequireDefault(require("system-sleep"));

var _readline = require("readline");

var _FirestoreConnection = _interopRequireDefault(require("./FirestoreConnection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// windows hack
if (process.platform === 'win32') {
  const rl = (0, _readline.createInterface)({
    input: process.stdin,
    output: process.stdout
  });
  rl.on('SIGINT', () => {
    process.emit('SIGINT');
  });
} // on SIGINT, exit program


process.on('SIGINT', () => {
  console.log('Caught interrupt signal');
  console.log('bye bye');
  process.exit();
});
/**
 * Block until a change is detected in a remote data document
 * @param {String} collection name of the collection
 * @param {String} document the id of the document to watch
 * @param {Function} mainWorkFunc the work to perform each time a change is detected
 */

const changeDetector = (collection, document, mainWorkFunc) => {
  for (;;) {
    // call main piece of work
    mainWorkFunc(); // look for changescc

    let changeCount = 0;

    const changeDetectedCallback = () => {
      changeCount += 1;

      if (changeCount > 1) {
        console.log('** REAL-TIME DATA CHANGE DETECTED **');
      }
    }; // monitor a document for changes


    new _FirestoreConnection.default().connect().monitorObject(document, changeDetectedCallback, collection);

    while (changeCount <= 1) {
      (0, _systemSleep.default)(5000);
    }
  }
};

var _default = changeDetector;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@vigilantapps/vipro-online-request-manager/dist/changeDetector.js
// module id = GkB0
// module chunks = 0